import { injectIntl } from "react-intl";
import { Box, Typography } from "@mui/material";
import { EmptyIcon } from "../../styles/images/";
import { EMPTY_MESSAGE } from "../../modules/language";
import { getMessageString } from "../../utility";

export const Empty = injectIntl(({ intl }) => (
  <Box className="empty">
    <EmptyIcon />
    <Typography>{getMessageString(intl, EMPTY_MESSAGE)}</Typography>
  </Box>
));
